"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
let CompanyPaymentDialog = class extends Vue {
  open() {
    this._companyPaymentDialog.show();
  }
  close() {
    this._companyPaymentDialog.hide();
  }
  copyCompanyName() {
    let copyText = this.$t("recharge.hint_2") + "\n" + this.$t("company_payment_dialog.company_info") + "\n" + this.$t("company_payment_dialog.content_description_company_name_label") + ":" + this.$t("company_payment_dialog.content_description_company_name") + "\n" + this.$t("company_payment_dialog.content_description_company_bank_label") + ":" + this.$t("company_payment_dialog.content_description_company_bank") + "\n" + this.$t("company_payment_dialog.content_description_company_account_label") + ":" + this.$t("company_payment_dialog.content_description_company_account");
    navigator.clipboard.writeText(copyText);
    this.$message.success(this.$t("company_payment_dialog.copy_success"));
  }
};
__decorateClass([
  Ref("company-payment-dialog")
], CompanyPaymentDialog.prototype, "_companyPaymentDialog", 2);
CompanyPaymentDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], CompanyPaymentDialog);
export {
  CompanyPaymentDialog as default
};
